// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"xX-z","sponsoredTooltipWrapper":"yX-z","sponsoredTooltip":"zX-z","newCard":"AX-z"};